import { Redirect } from 'expo-router';

import { routes } from 'navigation/routing';
import { LoyaltyProfile } from 'pages/loyalty/loyalty-profile/loyalty-profile';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export default function ProfileTab() {
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);

  if (!enableLoyaltyProfile) {
    return <Redirect href={routes.rewardsHistory} />;
  }

  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyProfile />
    </>
  );
}
